import React, { useState, useEffect, useRef, useContext } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import './confirmationModal.css';

const ConfirmationModalFakturaOvera = ({
  visible,
  onHide,
  onConfirmPrint,
  onConfirmValidate,
  onConfirmReject,
  idInvoice,
  children
}) => {

  const header = ( 
    <div>
      {idInvoice &&   <><Button
        label="Štampa"
        icon="pi pi-print"
        onClick={onConfirmPrint}
        severity="info"
        style={{marginRight:'2%'}}
      />
      <Button
        label="Prihvati"
        icon="pi pi-sign-in"
        onClick={onConfirmValidate} 
        severity="success" 
      />  
      <Button
        label="Odbij"
        style={{marginLeft:'2%'}}
        icon="pi pi-sign-out"
        onClick={onConfirmReject} 
        severity="danger" 
      /></>}
    </div>
  );

  const formatDateSR = (isoString) => {
  if (!isoString) return '';

  const d = new Date(isoString);

  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();

  return `${day}.${month}.${year}`;
};

const formatNumber = (value) => {
  if (value === null || value === undefined) return '-';
  return Number(value).toLocaleString('sr-RS', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

  return (
    <Dialog
      header={header}
      visible={visible}
      style={{ width: '50%' }}
      onHide={onHide}
      modal
      className="confirmation-modal"
    >
            {children}
    </Dialog>
  );
};

export default ConfirmationModalFakturaOvera;